<template>
    <div class="main">
        <div class="text-center">
            <img class="faq-usps__img mt-10" src="~@/assets/images/pages/faq/icons/faq.png" alt="FAQ">
            <h2 v-text="$t('FAQ_CAT')"></h2>
            <p class="px-8 pt-2 pb-4"
                v-text="$t('FAQ_CAT_QUESTIONS')"></p>
        </div>
        <div class="background--paper p-1 divider--container">
            <div class="divider-white--top"></div>
            <div class="container mx-auto flex items-center justify-center px-2 py-13">
                <faq-search :label="$t('FAQ_CAT_TYPE_SALIENT_WORDS')"></faq-search>
            </div>
            <div class="divider-white--bottom"></div>
        </div>
        <div>
            <h2 class="text-center pt-12 px-10 pb-3" v-text="$t('FAQ_CAT_KIND')"></h2>
        </div>

        <div class="flex flex-wrap">
            <faq-category-box
                v-for="(category, index) in notLoggedInCategories"
                :category="category"
                :key="index">
            </faq-category-box>
        </div>

        <div v-if="isUserLoggedIn" class="flex flex-wrap">
            <faq-category-box
                v-for="(category, index) in loggedInCategories"
                :category="category"
                :key="index">
            </faq-category-box>
        </div>
    </div>
</template>

<script>
import FaqSearch from '@/components/partials/faq/FaqSearch';
import FaqCategoryBox from '@/components/partials/faq/FaqCategoryBox';

export default {
    name: 'FaqCategories',
    computed: {
        isUserLoggedIn() {
            return this.$store.getters['auth/isUserLoggedIn'];
        },
        categories() {
            return this.$store.getters['faq/getCategories'];
        },
        loggedInCategories() {
            return this.$store.getters['faq/getLoggedInCategories'];
        },
        notLoggedInCategories() {
            return this.$store.getters['faq/getNotLoggedInCategories'];
        },
    },
    components: {
        FaqCategoryBox,
        FaqSearch,
    },
};
</script>
